import type { ExcelAction } from "./types";
import { scanAllWorksheets } from "../../regions/scanner";
import { openDataIslands } from "../dialog-host";

export const findDataIslands: ExcelAction = {
  id: "find-data-islands",
  label: "Find data islands",
  description:
    "Scan every worksheet for contiguous rectangular data regions; show in a mini-map dialog.",
  async run({ log }) {
    log("scanning all worksheets...");
    let sheets;
    try {
      sheets = await scanAllWorksheets();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`scan failed: ${message}`, "error");
      return;
    }

    const totalIslands = sheets.reduce((sum, s) => sum + s.islands.length, 0);
    const sheetsWithIslands = sheets.filter((s) => s.islands.length > 0).length;
    log(
      `found ${totalIslands} island(s) across ${sheetsWithIslands}/${sheets.length} sheet(s)`,
      totalIslands > 0 ? "success" : "info"
    );

    try {
      await openDataIslands(sheets);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`dialog failed: ${message}`, "error");
    }
  },
};
